<template>
    <new-student-backend-layout
        page-title="Computer Adaptive Test (CAT)"
        content-bg-color="white"
        header-bg-color="gray-100"
    >
        <template #page_header>
            <div class="flex gap-4">
                <div class="flex flex-col gap-4 py-8 pt-4">
                    <div class="flex flex-col gap-6">
                        <h1
                            v-if="$page.props.auth.user.provider_level_id == 3"
                            class="text-[26px] font-semibold text-gray-800"
                        >
                            Computer-Based Linear Exam (CBLE)
                        </h1>
                        <h1
                            v-else
                            class="text-[26px] font-semibold text-gray-800"
                        >
                            Computer Adaptive Test (CAT)
                        </h1>
                        <div
                            v-if="$page.props.auth.user.provider_level_id == 3"
                            class="text-[18px] text-gray-700"
                        >
                            Our computer adaptive test (CAT) provides the
                            closest parallel of what you’ll see on the NREMT
                            exam. For the AEMT level, we still provide a
                            computer-based linear exam (CBLE) because that’s
                            what you’ll see on test day.
                        </div>
                        <div v-else class="text-[18px] text-gray-700">
                            Our computer adaptive test (CAT) provides the
                            closest parallel of what you’ll see on the NREMT
                            exam. While this test is in its beta form, you’ll
                            have unlimited attempts, just be aware that you may
                            see repeat questions.
                            <!--                            Our computer adaptive test is the closest imitation-->
                            <!--                            of the actual NREMT exam. You’ll have-->
                            <!--                            <span class="font-semibold text-primary-525"-->
                            <!--                                >1 attempt</span-->
                            <!--                            >-->
                            <!--                            to complete this test.-->
                        </div>
                        <div class="flex items-center gap-4">
                            <StudentTakeCatTestModal
                                :in-progress-cat-attempt="
                                    $page.props.inProgressCatAttempt
                                "
                            >
                                <span
                                    v-if="$page.props.inProgressCatAttempt"
                                    class="[text-16px] whitespace-nowrap rounded bg-primary-525 px-3 py-2 text-white"
                                >Resume test ({{ resumeTimeRemaining }}
                                    minutes remaining)
                                </span>
                                <span
                                    v-else
                                    class="[text-16px] whitespace-nowrap rounded bg-primary-525 px-3 py-2 text-white"
                                >Take the test
                                </span>
                            </StudentTakeCatTestModal>
                        </div>
                    </div>
                </div>
                <div
                    class="hidden w-[500px] flex-none grid-cols-3 text-[16px] text-gray-700 lg:grid"
                >
                    <div
                        class="flex items-center border-b border-r border-gray-400 p-4"
                    >
                        Airway, Respiration and Ventilation
                    </div>
                    <div
                        class="flex items-center border-b border-r border-gray-400 p-4"
                    >
                        Cardiology and Resuscitation
                    </div>
                    <div class="flex items-center border-b border-gray-400 p-4">
                        Trauma
                    </div>
                    <div class="flex items-center border-r border-gray-400 p-4">
                        Medical, Obstetrics and Gynecology
                    </div>
                    <div class="flex items-center border-r border-gray-400 p-4">
                        EMS Operations
                    </div>
                </div>
            </div>
        </template>

        <template #content>
            <div class="px-4 py-4 lg:px-10">
                <div
                    v-if="$page.props.auth.user.provider_level_id == 3"
                    class="flex max-w-2xl flex-col gap-4 text-[16px] text-gray-700"
                >
                    <div class="">
                        <div class="text-[21px] font-semibold text-gray-800">
                            What is it?
                        </div>
                        <p class="py-2">
                            Computer Adaptive Tests determine competency through
                            the use of algorithms. Simply put, your answers to
                            each question, right or wrong, will dictate the
                            level of difficulty in the proceeding question. With
                            a CBLE, you’re shown a pre-determined number of
                            questions for each focus area at random.
                        </p>
                        <p class="py-2">
                            At the conclusion of your 135 question exam, the
                            scores from each focus area will be tallied. To
                            pass, you’ll need to have received a passing score
                            (70% or higher) in each focus area.
                        </p>
                        <p class="py-2">
                            For AEMTs, there’s a time limit of 2 hours and 15
                            minutes. That’s 135 minutes for 135 questions or one
                            minute per question. There’s a lot to get through in
                            that time frame, but students commonly report
                            finishing between 20-45 minutes early. luck!
                        </p>
                    </div>
                    <div class="">
                        <div class="text-[21px] font-semibold text-gray-800">
                            How many attempts do I get?
                        </div>
                        <p class="py-2">
                            During our beta, you’ll have unlimited attempts to
                            take this test. This may change with the full
                            release of our CBLE test simulation and/or when the
                            NREMT changes the AEMT test to a CAT test.
                        </p>
                        <p class="py-2">
                            For an accurate assessment, we recommend that you
                            take this test only after you’ve completed all of
                            your studying and think you’re ready to take the
                            NREMT.
                        </p>
                        <p class="py-2">
                            This test should provide a good proxy for how you
                            should expect to do on the NREMT.
                        </p>
                    </div>
                    <div class="">
                        <div class="text-[21px] font-semibold text-gray-800">
                            What should I do before taking this test?
                        </div>

                        <p class="py-2">A few things that will be helpful:</p>
                        <ul class="list list-disc pl-4">
                            <li>
                                Make sure you have
                                <span class="font-semibold">
                                    at least 2 hours and 15 minutes</span
                                >
                                of uninterrupted time.
                            </li>
                            <li>
                                Make sure you feel like you’re ready for the
                                NREMT,
                                <span>
                                    your
                                    <new-modal
                                        title="Readiness Score"
                                        size="4xl"
                                    >
                                        <template #trigger>
                                            <span
                                                class="hover:text-625 inline text-primary-525 underline hover:cursor-pointer"
                                            >Readiness Score ({{
                                                    $page.props
                                                        .studentReadinessScore
                                                        .score
                                                }}%)</span
                                            >
                                        </template>
                                        <template #content>
                                            <StudentReadinessDetails
                                                :score-percent="
                                                    $page.props
                                                        .studentCachedPerformance
                                                        .score
                                                "
                                                :score-details="
                                                    $page.props
                                                        .studentReadinessScore
                                                        .details
                                                "
                                            />
                                        </template>
                                    </new-modal>

                                    is a good indicator of how ready you
                                    are.</span
                                >
                            </li>
                        </ul>
                        <p class="py-2">Good luck!</p>
                    </div>
                    <div class="">
                        <StudentTakeCatTestModal
                            :in-progress-cat-attempt="$page.props.inProgressCatAttempt"
                        >
                            <span
                                v-if="$page.props.inProgressCatAttempt"
                                class="[text-16px] whitespace-nowrap rounded bg-primary-525 px-3 py-2 text-white"
                            >Resume test ({{ resumeTimeRemaining }}
                                minutes remaining)
                            </span>
                            <span
                                v-else
                                class="[text-16px] whitespace-nowrap rounded bg-primary-525 px-3 py-2 text-white"
                            >Take the test
                            </span>
                        </StudentTakeCatTestModal>
                    </div>
                </div>
                <div
                    v-else
                    class="flex max-w-2xl flex-col gap-4 text-[16px] text-gray-700"
                >
                    <div class="">
                        <div class="text-[21px] font-semibold text-gray-800">
                            What is it?
                        </div>

                        <p class="py-2">
                            Computer Adaptive Tests determine competency through
                            the use of algorithms. Simply put, your answers to
                            each question, right or wrong, will dictate the
                            level of difficulty in the proceeding question. At a
                            certain point, the algorithm will decide if you’ve
                            met the requirements for competency in each Focus
                            Area, or not.
                            <!-- Our computer adaptive test (CAT) provides the-->
                            <!-- closest parallel of what you’ll see on the NREMT-->
                            <!-- exam. You’ll start with easy questions, and the-->
                            <!-- algorithm will adjust the difficulty after each-->
                            <!-- answer.-->
                        </p>
                        <p class="py-2">
                            <span class="font-semibold">
                                <span
                                    v-if="
                                        $page.props.auth.user.provider_level
                                            .title === 'EMR'
                                    "
                                >
                                    For EMRs there’s a time limit of 1 hour and
                                    45 minutes, but since the exam is
                                    dynamically created based on your answers,
                                    its very common to finish earlier.
                                </span>
                                <span
                                    v-if="
                                        $page.props.auth.user.provider_level
                                            .title === 'EMT'
                                    "
                                >
                                    For EMTs there’s a time limit of 2 hours,
                                    but since the exam is dynamically created
                                    based on your answers, its very common to
                                    finish earlier.</span
                                >
                                <span
                                    v-if="
                                        $page.props.auth.user.provider_level
                                            .title === 'AEMT'
                                    "
                                >
                                    For AEMTs there’s a time limit of 2 hours
                                    and 15 minutes.</span
                                >
                                <span
                                    v-if="
                                        $page.props.auth.user.provider_level
                                            .title === 'Paramedic'
                                    "
                                >
                                    For Paramedics there’s a time limit of 2
                                    hours and 30 minutes, but since the exam is
                                    dynamically created based on your answers,
                                    its very common to finish earlier.</span
                                >
                            </span>
                        </p>
                        <p class="py-2">
                            As with the NREMT, you must receive a passing score
                            in each of the five (5) NREMT Focus Areas (shown
                            above) to pass the test.
                        </p>
                    </div>
                    <div class="">
                        <div class="text-[21px] font-semibold text-gray-800">
                            How many attempts do I get?
                        </div>

                        <p class="py-2">
                            During our beta you'll have unlimited attempts to
                            take this test. This may change with the full
                            release of our CAT test simulation. For an accurate
                            assessment, we recommend that you take this test
                            only after you’ve completed all of your studying and
                            think you’re ready to take the NREMT.
                            <!--                            You’ll get 1 attempt to take this simulation test.-->
                            <!--                            We recommend that you take this test only after-->
                            <!--                            you’ve completed all of your studying and think-->
                            <!--                            you’re ready to take the NREMT.-->
                        </p>
                        <p class="py-2">
                            This test should provide a good proxy for how you
                            should expect to do on the NREMT.
                        </p>
                    </div>
                    <div class="">
                        <div class="text-[21px] font-semibold text-gray-800">
                            What should I do before taking this test?
                        </div>

                        <p class="py-2">A few things that will be helpful:</p>
                        <ul class="list list-disc pl-4">
                            <li>
                                Make sure you have
                                <span class="font-semibold">
                                    at least
                                    <span
                                        v-if="
                                            $page.props.auth.user.provider_level
                                                .title === 'EMR'
                                        "
                                    >1 hour and 45 minutes</span
                                    >
                                    <span
                                        v-if="
                                            $page.props.auth.user.provider_level
                                                .title === 'EMT'
                                        "
                                    >2 hours</span
                                    >
                                    <span
                                        v-if="
                                            $page.props.auth.user.provider_level
                                                .title === 'AEMT'
                                        "
                                    >2 hours and 15 minutes</span
                                    >
                                    <span
                                        v-if="
                                            $page.props.auth.user.provider_level
                                                .title === 'Paramedic'
                                        "
                                    >2 hours and 30 minutes</span
                                    >
                                </span>
                                of uninterrupted time.
                            </li>
                            <li>
                                Make sure you feel like you’re ready for the
                                NREMT,
                                <span>
                                    your
                                    <new-modal
                                        title="Readiness Score"
                                        size="4xl"
                                    >
                                        <template #trigger>
                                            <span
                                                class="hover:text-625 inline text-primary-525 underline hover:cursor-pointer"
                                            >Readiness Score ({{
                                                    $page.props
                                                        .studentReadinessScore
                                                        .score
                                                }}%)</span
                                            >
                                        </template>
                                        <template #content>
                                            <StudentReadinessDetails
                                                :score-percent="
                                                    $page.props
                                                        .studentReadinessScore
                                                        .score
                                                "
                                                :score-details="
                                                    $page.props
                                                        .studentReadinessScore
                                                        .details
                                                "
                                            />
                                        </template>
                                    </new-modal>

                                    is a good indicator of how ready you
                                    are.</span
                                >
                            </li>
                        </ul>
                        <p class="py-2">Good luck!</p>
                    </div>
                    <div class="">
                        <StudentTakeCatTestModal
                            :in-progress-cat-attempt="$page.props.inProgressCatAttempt"
                        >
                            <span
                                v-if="$page.props.inProgressCatAttempt"
                                class="[text-16px] whitespace-nowrap rounded bg-primary-525 px-3 py-2 text-white"
                            >Resume test ({{ resumeTimeRemaining }}
                                minutes remaining)
                            </span>
                            <span
                                v-else
                                class="[text-16px] whitespace-nowrap rounded bg-primary-525 px-3 py-2 text-white"
                            >Take the test
                            </span>
                        </StudentTakeCatTestModal>
                    </div>
                </div>
            </div>
        </template>
    </new-student-backend-layout>
</template>

<script>
import NewStudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import StudentTakeCatTestModal from "@/Pages/NewStudentBackend/StudentTakeCatTestModal.vue";
import StudentReadinessDetails from "@/Pages/NewStudentBackend/StudentReadinessDetails.vue";
import StudentReadinessScoreWidget from "@/Components/StudentReadinessScoreWidget.vue";
import NewModal from "@/Components/NewModal.vue";
import dayJs from "dayjs";

export default {
    name: "StudentComputerAdaptiveTestIndex",
    components: {
        NewModal,
        StudentReadinessScoreWidget,
        StudentReadinessDetails,
        StudentTakeCatTestModal,
        NewStudentBackendLayout,
    },
    props: {},
    data() {
        return {
            resumeTimeRemaining: 0,
        };
    },
    methods: {
        dayJs,
    },
    mounted() {
        if (this.$page.props.inProgressCatAttempt) {
            this.resumeTimeRemaining =
                this.$page.props.inProgressCatAttemptTimeRemaining;

            setInterval(() => {
                this.resumeTimeRemaining--;
                if (this.resumeTimeRemaining <= 0) {
                    this.resumeTimeRemaining = 0;
                }
            }, 1000 * 60);
        }
    },
};
</script>
